export default __webpack_public_path__ + "static/Geek-bd1233c7dab3cd40936f8ce75e289772.png";